export default __webpack_public_path__ + "static/media/eliminar.3ae909f0.svg";